import React from 'react';
import { useRovingFocus } from './useRovingFocus.js';
/**
 * Grid-aware roving-focus keyboard navigation for the app launcher tile grid.
 *
 * Thin adapter over the shared {@link useRovingFocus} hook (the single roving
 * implementation), exposing the launcher's tile-oriented vocabulary. `count`
 * is the number of focusable tiles in visual order; `columns` is the grid
 * column count (3 for the launcher).
 */
export const useAppLauncherKeyboardNav = (count, columns) => {
    const { activeIndex, getTabIndex, registerItem, handleItemKeyDown, focusFirstItem } = useRovingFocus(count, columns);
    return {
        activeIndex,
        getTabIndex,
        registerTile: registerItem,
        handleTileKeyDown: handleItemKeyDown,
        focusFirstTile: focusFirstItem,
    };
};
//# sourceMappingURL=useAppLauncherKeyboardNav.js.map